import { Component, ElementRef, EventEmitter, Input, OnInit, Optional, Output, Self, ViewChild } from '@angular/core';
import { ControlValueAccessor, FormGroupDirective, NgControl } from '@angular/forms';
import { SelectItem } from 'primeng/api';

@Component({
    selector: 'superflex-dropdown',
    template:`
        <label for="controltext"> {{ label }} <span *ngIf="ngControl.control.errors?.required" style="font-weight: 900;">*</span> </label>
        <p-dropdown
            [formControl]='ngControl.control'
            [optionLabel]="optionLabel" 
            [optionValue]="optionValue"
            [placeholder]="placeholder"
            [options]="options"
            [filter]="filter"
            [showClear]="!readonly"
            [readonly]="readonly"
            [virtualScroll]="virtualScroll"
            itemSize="15"
            (onChange)="onChange.emit($event)"
            [autoDisplayFirst]="autoDisplayFirst" >
        </p-dropdown>
    <small *ngIf="readonly" style="color: #9e9e9e;" >Read Only</small>
    <app-error [input]="ngControl.control"  [form]="form" ></app-error>
    `,
    host: {'class': 'p-field'}
})
export class DropdownComponent implements OnInit, ControlValueAccessor {

    public checked: boolean;
    public focused: boolean;

    @Input() isDisabled: boolean = false
    @Input() readonly: boolean = false
    @Input() autoDisplayFirst: boolean = false
    @Input() label: string = ''
    @Input() filter: boolean = false
    @Input() virtualScroll: boolean = true
    @Input() options: SelectItem[] = []
    @Input() optionLabel = '';
    @Input() optionValue = '';

    @Output() onChange = new EventEmitter<any>()

    placeholder = '';
    @ViewChild('rb') inputViewChild: ElementRef;

    @Output() onFocus: EventEmitter<any> = new EventEmitter();
    @Output() onBlur: EventEmitter<any> = new EventEmitter();

    form!: FormGroupDirective;
    constructor(@Self() @Optional() public ngControl: NgControl, private rootFormGroup: FormGroupDirective) {
        this.form = this.rootFormGroup;
        if (this.ngControl) {
            ngControl.valueAccessor = this
        }
    }

    writeValue(value: any): void {
        //
    }
    registerOnChange(fn: any): void {
        //
    }
    registerOnTouched(fn: any): void {
        //
    }
    setDisabledState?(isDisabled: boolean): void {
        //
    }

    public onModelTouched = () => {/** */ };

    ngOnInit(): void {
        if (this.isDisabled) {
            this.ngControl.control.disable()
        } else {
            this.ngControl.control.enable()
        }
    }

    onInputFocus(event): void {
        this.focused = true;
        this.onFocus.emit(event);
    }

    onInputBlur(event): void {
        this.focused = false;
        this.onModelTouched();
        this.onBlur.emit(event);
    }

    focus(): void {
        this.inputViewChild.nativeElement.focus();
    }

    ngOnDestroy(): void {
        // this.registry.remove(this);
    }

    getPlaceholderPrefix(): string {
        return this.isDisabled ? '' : 'FORM_ERRORS.placeholder';
    }
}
